import ReportCheckINOUT from './ReportCheckINOUT'
import ReportCheckINOUTLeader from './ReportCheckINOUTLeader'
import ReportCheckINOUTToday from './ReportCheckINOUTToday'
import ReportCheckINOUTTodayLeader from './ReportCheckINOUTTodayLeader'
import ReportCheckINOUTTodayBranch from './ReportCheckINOUTTodayBranch'
import ManageCheckINOUT from './ManageCheckINOUT'
import ManageCheckINOUTBranch from './ManageCheckINOUTBranch'
import AdjustRequest from './AdjustRequest'
import AdjustRequestBranch from './AdjustRequestBranch'
import AdjustRequestHeader from './AdjustRequestHeader'
import ManageCheckINOUTAdjust from './ManageCheckINOUTAdjust'

export default {
  ReportCheckINOUT,
  ReportCheckINOUTLeader,
  ReportCheckINOUTToday,
  ReportCheckINOUTTodayLeader,
  ReportCheckINOUTTodayBranch,
  ManageCheckINOUT,
  ManageCheckINOUTBranch,
  AdjustRequest,
  AdjustRequestBranch,
  AdjustRequestHeader,
  ManageCheckINOUTAdjust
}



// WEBPACK FOOTER //
// ./src/components/HRM/CheckINOUT/index.js